import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import SettingDomainState, { ISettingDomainData } from './states'
import _ from 'lodash'
const mutations: MutationTree<SettingDomainState> = {
  [mutationType.SEND_DOMAIN](
    state: SettingDomainState,
    data: string,
  ): void {
    state.domain = data
  },
  [mutationType.GET_DOMAIN](
    state: SettingDomainState,
    data: ISettingDomainData,
  ): void {
    state.lists = data
  },
  [mutationType.DELETE_DOMAINS](
    state: SettingDomainState,
    data: string[],
  ): void {
    state.id = data
  },
}

export default mutations
